module.exports = __webpack_public_path__ + "c4615a3adbb3a5f712129eb5b4cdb8e2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/american-express.png
// module id = 1017
// module chunks = 0